import React from "react";
import { getPayrollTotalPresentation } from "../../../helpers/payrollReport";

/**
 * Payroll totals block — reuses estimate report totals styling.
 */
export function PayrollReportTotalSection({
  reportModel,
  variant = "preview",
}) {
  const presentation = getPayrollTotalPresentation(reportModel);
  if (!presentation) return null;

  const isPrint = variant === "print";
  const rowClass = isPrint ? "erp-totals-row" : "er-summary-row";
  const emphasisRowClass = isPrint
    ? "erp-totals-row erp-totals-row--grand"
    : "er-summary-row er-summary-row--emphasis";
  const blockClass = isPrint ? "erp-totals-block" : "er-report-totals";

  return (
    <div className={blockClass}>
      {presentation.lines.map((line) => (
        <div
          key={line.key}
          className={line.emphasis ? emphasisRowClass : rowClass}
        >
          <span>{line.label}</span>
          <span>{line.value}</span>
        </div>
      ))}
    </div>
  );
}
